export default "__VITE_PUBLIC_ASSET__fb583e4d__"